<template>
  <div class="container">
    <div
      v-show="message.state"
      class="alert alert-dismissible border-0 fade show"
      :class="message.type"
      role="alert"
    >
      <button
        type="button"
        class="close"
        data-dismiss="alert"
        aria-label="Close"
      >
        <span aria-hidden="true">&times;</span>
      </button>
      <strong>{{ message.msg }}</strong>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-body">
            <h2>Fundraising</h2>
            <br />
            <form>
              <div class="form-row">
                <div class="form-group col-md-6">
                  <div class="form-row">
                    <!-- Objetive -->
                    <div class="form-group col-md-6">
                      <label>Goal</label>
                      <input
                        v-model="goal"
                        type="number"
                        class="form-control"
                        step="any"
                        min="0"
                        @change="getAssetData"
                      />
                    </div>
                    <!-- Coin -->
                    <div class="form-group col-md-4">
                      <label>Coin</label>
                      <v-select
                        v-model="coin_selected"
                        :options="currencies"
                      ></v-select>
                    </div>
                  </div>
                </div>

                <div class="form-group col-md-6">
                  <div class="form-row">
                    <!-- startdate -->
                    <div class="form-group col-md-4">
                      <label>Start Date</label>
                      <input
                        v-model="start_date"
                        type="date"
                        class="form-control"
                      />
                    </div>
                    <!-- days -->
                    <div class="form-group col-md-4">
                      <label>Duration (Days)</label>
                      <input
                        v-model="days_duration"
                        type="number"
                        class="form-control"
                        @keyup="calculateDeadline"
                      />
                    </div>
                    <!-- deadline -->
                    <div class="form-group col-md-4">
                      <label>Deadline</label>
                      <input
                        v-model="deadline"
                        type="date"
                        class="form-control"
                        disabled
                      />
                    </div>
                  </div>
                </div>
              </div>
              <h2 class="card-title mt-3">Investment Levels</h2>
              <br />

              <div class="form-row">
                <div class="form-group col-md-6 checkbox">
                  <label> Accepted Currencies</label>
                  <br />
                  <input type="checkbox" value="" checked disabled /> ETH
                  <img
                    id="eth_icon"
                    class="img-fluid rounded-circle"
                    src="../../../public/coins/ETH_Icon.png"
                    alt="Ether coin icon"
                  />
                </div>

                <div class="form-group col-md-6">
                  <!-- minimum and maximum -->
                  <div class="form-row">
                    <div class="form-group col-md-6">
                      <label>Minimum</label>
                      <input
                        v-model="objetive_minimum"
                        type="number"
                        class="form-control"
                        @change="checkSubtotal"
                      />
                    </div>
                    <div class="form-group col-md-6">
                      <label>Maximum</label>
                      <input
                        v-model="objetive_maximum"
                        type="number"
                        class="form-control"
                        @change="checkSubtotal"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </form>
            <br />
            <h4 class="mb-3">
              You can change the prices of the tokens by periods allowing the
              programming of discounts for early purchase or keep the fixed
              price.
              <button
                type="button"
                class="btn btn-outline-info btn-sm btn-rounded"
                @click="show_popup_tokens = !show_popup_tokens"
              >
                <i class="fas fa-info"></i>
              </button>
            </h4>

            <!-- END POP-UP AUTOMATIC TOKEN CALCULATION -->
            <div
              v-show="show_popup_tokens"
              class="alert alert-info alert-dismissible border-0 fade show mt-1"
              role="alert"
            >
              <button
                type="button"
                class="close"
                @click="show_popup_tokens = !show_popup_tokens"
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <p class="text-mutted text-xs">
                Note: The value of the price of the self-generated token for
                each level may not be the desired or not correct, since its
                calculation depends on the sum of the previous prices.
              </p>
            </div>
            <!-- END POP-UP AUTOMATIC TOKEN CALCULATION -->

            <!-- TABLE INVESTMENT LEVELS -->
            <div class="row">
              <div class="col-md-12">
                <!--INFO--->
                <div
                  v-if="
                    total_tokens != 0 && goal != 0 && coin_selected != 'Choose'
                  "
                  class="alert alert-info alert-dismissible border-0 fade show mt-1"
                  role="alert"
                >
                  Remember that you have {{ total_tokens }}
                  {{ token_symbol }} tokens to collect {{ coin_selected }}
                  {{ goal }}
                </div>
                <!-- END INFO-->

                <!--ALERT LIMITS MAX MIN-->
                <div
                  v-if="alert_limits"
                  class="alert alert-danger border-0 fade show mt-1"
                  role="alert"
                >
                  {{ alert_limits_text }}
                </div>
                <!-- END ALERT LIMITS MAX MIN-->

                <div class="table-responsive">
                  <table class="table">
                    <thead class="bg-primary text-white text-center">
                      <tr>
                        <th>Level</th>
                        <th>Since</th>
                        <th>Until</th>
                        <th>Number of Tokens</th>
                        <th v-if="coin_selected != 'Choose'">
                          Token Price ({{ coin_selected }})
                        </th>
                        <th v-else>Token Price</th>
                        <th v-if="coin_selected != 'Choose'">
                          Subtotal ({{ coin_selected }})
                        </th>
                        <th v-else>
                          Subtotal
                        </th>
                      </tr>
                    </thead>
                    <tbody class="border border-primary">
                      <tr v-for="(level, i) in row" :key="i">
                        <td>{{ level.level_number }}</td>
                        <td>
                          <input
                            v-model="level.since"
                            type="date"
                            class="form-control"
                            disabled
                          />
                        </td>
                        <td>
                          <input
                            v-model="level.until"
                            type="date"
                            class="form-control"
                            @change="evaluateDate(level, i)"
                          />
                        </td>
                        <td>
                          <input
                            v-model="level.tokens"
                            type="number"
                            class="form-control"
                            step="any"
                            min="0"
                            @change="calculate_subtotal(level, i)"
                          />
                        </td>
                        <td>
                          <input
                            v-model="level.token_price"
                            type="number"
                            class="form-control"
                            step="any"
                            min="0"
                            @change="calculate_subtotal(level, i)"
                          />
                        </td>
                        <td>
                          <input
                            v-model="level.subtotal"
                            type="number"
                            class="form-control"
                            disabled
                          />
                        </td>
                      </tr>
                    </tbody>
                    <tfoot class="border border-primary">
                      <tr>
                        <td colspan="3" class="text-right">Total Tokens</td>
                        <td
                          class="text-right"
                          :class="[
                            token_reached ? 'text-success' : 'text-danger',
                          ]"
                        >
                          {{ token_symbol }}: {{ token_accum }}
                        </td>
                        <!---->
                        <td colspan="1" class="text-right">
                          TOTAL FUNDS RAISE
                        </td>

                        <td
                          class="text-right"
                          :class="[
                            goal_reached ? 'text-success' : 'text-danger',
                          ]"
                        >
                          {{ coin_selected === 'Choose' ? '' : coin_selected }}
                          {{ funds_accum }}
                        </td>
                      </tr>
                    </tfoot>
                  </table>

                  <div class="text-left ml-3 mb-3">
                    <button
                      type="button"
                      class="btn btn-info btn-rounded mr-3"
                      @click="addNewRow"
                    >
                      <i class="fas fa-plus-circle"></i>
                    </button>

                    <button
                      type="button"
                      class="btn btn-danger btn-rounded"
                      @click="deleteLastRow"
                    >
                      <i class="fas fa-trash"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <!-- END TABLE INVESTMENT LEVELS -->

            <br />
            <br />
            <div class="text-right">
              <button
                type="button"
                class="btn btn-outline-success btn-rounded"
                @click="completeDividends()"
              >
                <i class="fas fa-check"></i> Save
              </button>
              <br />
              <br />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as move_tabs from './js/movetabs.js';
import * as moment from 'moment/moment';
export default {
  name: 'AssetFundraising',
  components: {},
  filters: {
    format: function(num) {
      let formatter = new Intl.NumberFormat('en');
      return formatter.format(num);
    },
  },
  data() {
    return {
      message: {
        state: false,
        msg: '',
        type: '',
      },
      token_symbol: '',
      alert_limits: false,
      show_popup_tokens: false,
      alert_limits_text: '',
      assetId: '',
      userId: '',
      currencies: [],
      goal: 0.0,
      coin_selected: 'Choose',
      start_date: '',
      deadline: '',
      days_duration: 0,
      objetive_minimum: 0,
      objetive_maximum: 0,
      total_tokens: 0.0,
      token_accum: 0,
      funds_accum: 0.0,
      goal_reached: false,
      token_reached: false,
      currency: 'ETH',
      today: '',
      current_token_price: 0.0,
      row: [
        {
          level_number: 1,
          since: '',
          until: '',
          tokens: 0,
          token_price: 0.0,
          subtotal: 0.0,
        },
      ],
    };
  },
  created() {
    this.userId = JSON.parse(localStorage.getItem('user')).userId;
    this.loadCurrencies();
    this.today = moment().format('YYYY-MM-DD');
  },
  methods: {
    completeDividends() {
      this.getAssetData();
      this.message.state = false;
      if (!this.emptyFields()) {
        const Data = {
          userId: this.userId,
          assetId: this.assetId,
          Objetive: parseFloat(this.goal),
          Coin: this.coin_selected,
          StartDate: new Date(this.start_date),
          Deadline: new Date(this.deadline),
          AcceptCurrenie: this.currency,
          Minimum: parseFloat(this.objetive_minimum),
          Maximum: parseFloat(this.objetive_maximum),
          Recaudation_days: parseInt(this.days_duration),
          Row: this.row,
          CreateDate: new Date(this.today),
          // something
        };
        console.log(Data);
        this.$http
          .post(`/asset/Fund/Register`, Data)
          .then(resp => {
            this.message.type = 'alert-success';
            this.message.msg = resp.data.message;
            this.message.state = true;
            this.updateLocalStorage();
            this.scrollNavigator();
            this.changeTabAndNextStep();
            return;
          })
          .catch(err => {
            this.message.msg = err.response.data.message;
            this.message.type = 'alert-warning';
            this.message.state = true;
            this.scrollNavigator();
            return;
          });
      } else {
        this.message.type = 'alert-warning';
        this.message.msg = 'One or more fields remain to be completed';
        this.message.state = true;
        this.scrollNavigator();
      }
    },
    evaluateDate(level, i) {
      /* Comprobacion de la fecha qwue el usuario elija como "until"
       en cada nivel*/
      let current = moment(level.until);
      let deadline = moment(this.deadline);
      let since = moment(level.since);
      // si until es mayor al deadline, se le asigna vacio
      // si until es menor al since del nivel i, se le asigna vacio
      if (level.until != '') {
        if (current > deadline) level.until = '';
        if (current < since) level.until = '';
      }
      /* si el usuario necesita editar la fecha until de un nivel actual,
         habiendo definido ya un nivel siguiente, al since del nivel siguiente
        se le suma until(n-1)+1 */
      if (typeof this.row[i + 1] != 'undefined') {
        this.row[i + 1].since = this.addDaysToDate(current, 1);
      }
    },
    // eslint-disable-next-line no-unused-vars
    calculate_subtotal(level, i) {
      // recalculo de subtotales para cada nivel
      level.subtotal = parseFloat(level.tokens * level.token_price).toFixed(2);
      this.funds_accum = this.fundsRaiseAccum(); // acumulador de fondos
      this.token_accum = this.tokensAccum(); // acumulador de tokens

      /* variable booleana que permite que se muestre el total acumulado
      de los fondos en color verde o rojo dependiendo de si se llega a la meta */
      if (this.funds_accum != this.goal) this.goal_reached = false;
      else this.goal_reached = true;

      /* variable booleana que permite que se muestre el total acumulado
      del token en color verde o rojo dependiendo de si se llega a la meta */
      if (this.token_accum != this.total_tokens) this.token_reached = false;
      else this.token_reached = true;

      if (this.token_accum > this.total_tokens) {
        this.alert_limits = true;
        this.alert_limits_text =
          'Warning: you cannot add another level because the accumulated tokens exceed the total tokens to collect';
      } else {
        this.alert_limits = false;
      }

      /*Si fecha de hoy es menor a Since 1 = Token Prince 1
      Si fecha de hoy esta entre Since i y Until i = Token Prince i
      Si fecha > ultimo until Token Price = Token n


      if (this.today < level[0].since){
        this.current_token_price = level.token_price
      }else if(this.today >= level[i].since && this.today <= level[i].until){
         this.current_token_price = level[i].token_price
      }else if(this.today > level[n].until){
         this.current_token_price = level[n].token_price
      }*/

      /* Se comprueba que el subtotal calculado esté entre los limites maximos y minimos
      definidos, la logica controla una alerta y su mensaje dependiendo del caso */
      if (level.subtotal < parseFloat(this.objetive_maximum)) {
        // eslint-disable-next-line no-irregular-whitespace
        this.alert_limits_text = `Warning: In the level ${level.level_number} the subtotal is less than the maximum investment, please modify the values ​​in the corresponding row.`;
        this.alert_limits = true;
      } else if (level.subtotal < parseFloat(this.objetive_minimum)) {
        // eslint-disable-next-line no-irregular-whitespace
        this.alert_limits_text = `Warning: In the level ${level.level_number} the subtotal is less than the minimum investment, please modify the values ​​in the corresponding row.`;
        this.alert_limits = true;
      } else {
        this.alert_limits = false;
      }
    },
    fundsRaiseAccum() {
      // acumula el subtotal de todos los niveles de inversion
      let subtotal = 0;
      for (let level in this.row) {
        subtotal = subtotal += parseFloat(this.row[level].subtotal);
      }
      return subtotal;
    },
    tokensAccum() {
      // acumula la cantidad de tokens de todos los niveles de inversión
      let subtotal_tokens = 0;
      for (let level in this.row) {
        subtotal_tokens += parseFloat(this.row[level].tokens);
      }
      return subtotal_tokens;
    },
    calculateDeadline() {
      this.goal = parseFloat(this.goal);
      /* calcula el deadline una vez establecidos la fecha de inicio y 
      los dias de recaudación, además calcula la primera fila de la tabla
      como nivel de inversión por defecto*/
      if (this.start_date && this.start_date) {
        // se calcula el deadline
        this.deadline = this.addDaysToDate(this.start_date, this.days_duration);
        // y de una vez se asignan los valores para el primer nivel de inversión.
        this.row[0].since = this.start_date;
        this.row[0].until = this.deadline;
        this.row[0].tokens = this.total_tokens;
        this.row[0].token_price = this.goal / this.total_tokens;
        this.row[0].subtotal = parseFloat(
          this.row[0].tokens * this.row[0].token_price
        ).toFixed(2);
      }
      this.funds_accum = this.goal;
      this.token_accum = this.total_tokens;
      this.token_reached = true;
      this.goal_reached = true;
    },
    addDaysToDate(date, days) {
      // dada una fecha y un numero de dias, se le suman los dias a la fecha
      date = moment(date);
      return date.add(days, 'days').format('YYYY-MM-DD');
    },
    loadCurrencies() {
      // carga la lista de monedas de la operación
      let currenciesJSON = require('./js/currencies.json');
      //let curr = [];
      for (let k in currenciesJSON) this.currencies.push(k);
    },
    addNewRow() {
      /* Agrega una nueva fila a la tabla (un nuevo nivel de inversión)
        y realiza el calculo automatico del nuevo nivel a partir de los datos 
        existentes*/

      let n = this.row.length;
      let last_until = this.row[this.row.length - 1].until;
      let goalCompleted =
        this.token_accum < this.total_tokens && this.funds_accum < this.goal;

      // Si se llegó a la meta no es necesaria una nueva fila
      if (goalCompleted && !this.alert_limits && this.goal != 0) {
        if (last_until === this.deadline || last_until === '') {
          this.row[this.row.length - 1].until = '';
          return;
        } else {
          if (this.row[this.row.length - 1].until)
            last_until = this.addDaysToDate(
              this.row[this.row.length - 1].until,
              1
            );
          let tok = this.tokensAccum();
          // recalculamos los tokens faltantes para completar la meta
          let next_level_tokens = this.total_tokens - tok;
          let next_level_token_price =
            (this.goal - this.fundsRaiseAccum()) / next_level_tokens;
          // recalculamos el token price faltante  para completar la meta

          let newRow = {
            level_number: n + 1,
            since: last_until,
            until: this.deadline,
            tokens: next_level_tokens,
            token_price: next_level_token_price,
            subtotal: next_level_tokens * next_level_token_price,
          };

          this.row.push(newRow);
          this.calculate_subtotal(this.row[n], n);
        }
      }
    },
    deleteLastRow() {
      let n = this.row.length;
      if (n > 1) {
        this.row.splice(-1, 1);
        this.row[this.row.length - 1].until = this.deadline;
        this.calculate_subtotal(
          this.row[this.row.length - 1],
          this.row.length - 1
        );
      }
    },
    checkSubtotal() {
      this.objetive_maximum = parseFloat(this.objetive_maximum);
      this.objetive_minimum = parseFloat(this.objetive_minimum);
      for (let level in this.row) {
        if (
          parseFloat(this.row[level].subtotal) < this.objetive_maximum ||
          parseFloat(this.row[level].subtotal) < this.objetive_minimum
        ) {
          this.alert_limits_text =
            'Warning: you must modify investment levels to adjust to the new minimum and maximum investment values';
          this.alert_limits = true;
        } else {
          this.alert_limits = false;
        }
      }
    },
    changeTabAndNextStep() {
      // wait 2 seconds to change the panel and move the step-bar
      setTimeout(() => {
        this.$emit('update', 7);
        move_tabs.moveTab();
      }, 2000);
    },
    getAssetData() {
      if (localStorage.getItem('asset')) {
        this.assetId = JSON.parse(localStorage.getItem('asset')).assetId;
        this.total_tokens = parseFloat(
          JSON.parse(localStorage.getItem('asset')).total_tokens
        );
        this.token_symbol = JSON.parse(
          localStorage.getItem('asset')
        ).token_symbol;
      }
    },
    scrollNavigator() {
      // scroll to the top of the browser
      // so that the user can view the alert
      window.scroll({
        top: -5000,
        behavior: 'smooth',
      });
    },
    emptyFields() {
      return (
        this.userId === '' ||
        this.assetId === '' ||
        this.goal === 0 ||
        this.coin_selected === 'Choose' ||
        this.start_date === '' ||
        this.deadline === '' ||
        this.currency === '' ||
        this.objetive_minimum === 0 ||
        this.objetive_maximum === 0 ||
        this.days_duration === 0
      );
    },
    updateLocalStorage() {
      let asset = JSON.parse(localStorage.getItem('asset'));
      asset.start_date = this.start_date;
      asset.currencies = this.currency;
      asset.deadline = this.deadline;
      asset.coinbase = this.coin_selected;
      asset.goal = this.goal;
      asset.current_token_price = this.row[0].token_price;
      localStorage.setItem('asset', JSON.stringify(asset));
    },
  },
};
</script>

<style></style>

<tr>
  <td colspan="5" class="text-right">Total Tokens</td>
  <td class="text-right">500.000</td>
</tr>
<tr>
  <td colspan="5" class="text-right">
    TOTAL FUNDS RAISE
  </td>
  <td class="text-right">$1.000.000</td>
</tr>
